import * as React from 'react';

import Sharrow16 from './Sharrow16';

export const sharrow16 = () => <Sharrow16 />;

export default {
    title: 'Icon/Line/Sharrow16',
    component: Sharrow16,
    parameters: {
        notes: "`import Sharrow16 from 'box-ui-elements/es/icon/line/Sharrow16';`",
    },
};
